export const DEFINE_MODULE = {
  name: "nhân viên",
  fields: "employee",
}
